var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReplace = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9999 12.7591C23.9969 13.013 23.8655 13.2482 23.6509 13.3839L14.6509 19.0753C14.4198 19.2214 14.1276 19.2302 13.8882 19.0983C13.6487 18.9664 13.5 18.7147 13.5 18.4414L13.5 13.5C7.47381 13.5 3.2736 15.9314 1.99719 17.0615C1.68707 17.3361 1.21307 17.3073 0.938484 16.9972C0.663898 16.6871 0.692705 16.2131 1.00283 15.9385C2.04109 15.0192 4.43297 13.56 7.82758 12.6996C4.45467 11.8325 2.07537 10.4558 1.01988 9.57619C0.701673 9.31101 0.65868 8.83809 0.923853 8.51988C1.18903 8.20167 1.66195 8.15868 1.98016 8.42385C3.28964 9.51509 7.47488 11.8099 13.5 11.9889V6.75005C13.5 6.47345 13.6522 6.21931 13.8961 6.08879C14.14 5.95828 14.4359 5.97258 14.666 6.12601L23.666 12.126C23.8773 12.2669 24.003 12.5051 23.9999 12.7591ZM15 8.15143V12.7445L15 12.75L15 12.7556V17.0797L21.873 12.7334L15 8.15143Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReplace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/replace.ff58952c2ff237d044084c33528739ce.svg";